import { useEffect, useRef } from "react";

const MapCanvas = ({ mapName = "", className = "" }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");

        if (mapName !== "") {
            let mapBackgroundImage = new Image();
            mapBackgroundImage.src = require(`assets/imgs/testings/${mapName}`);
            mapBackgroundImage.onload = () => {
                let wRatio = canvas.width / mapBackgroundImage.width;
                let hRatio = canvas.height / mapBackgroundImage.height;
                let ratio = Math.min(wRatio, hRatio);
                context.drawImage(
                    mapBackgroundImage,
                    0,
                    0,
                    mapBackgroundImage.width,
                    mapBackgroundImage.height,
                    0,
                    0,
                    mapBackgroundImage.width * ratio,
                    mapBackgroundImage.height * ratio
                );
            };
        }
    }, []);

    return <canvas className={className} ref={canvasRef} />;
};

export default MapCanvas;
